import Button from '@components/designSystem/Button'
import useTypedTranslation from '@hooks/useTypedTranslation'
import { routesFactory } from '@utils/routes.ts'

function NoStoreAccess() {
  const { t } = useTypedTranslation()
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center gap-6">
      <span className="mb-2 text-center text-2xl font-semibold tracking-wide md:text-3xl">
        {t('storeSelection.noStoreAccess.title')}
      </span>
      <span className="text-center text-lg text-gray-500">
        {t('storeSelection.noStoreAccess.subtitle')}
      </span>
      <Button size='xl' href={routesFactory.storeSelection(true)}>
        {t('storeSelection.noStoreAccess.back')}
      </Button>
    </div>
  )
}

export default NoStoreAccess